import { Breadcrumb, HeaderToolbar } from "@xola/ui-kit";
import React from "react";
import { TermsTemplateList } from "../../components/Agent/TermsTemplate/TermsTemplateList";
import { ColumnLayout } from "../../components/Layout/ColumnLayout";
import { Page } from "../Page";

export const TermsTemplateListPage = () => {
    return (
        <Page title="Terms Templates">
            <ColumnLayout>
                <HeaderToolbar>
                    <HeaderToolbar.Breadcrumb>
                        <Breadcrumb.Item>Distribution</Breadcrumb.Item>
                        <Breadcrumb.Item>Terms Templates</Breadcrumb.Item>
                    </HeaderToolbar.Breadcrumb>
                </HeaderToolbar>

                <ColumnLayout.Fill>
                    <TermsTemplateList />
                </ColumnLayout.Fill>
            </ColumnLayout>
        </Page>
    );
};
